var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStairsicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16H4a2 2 0 01-2-2v-2a2 2 0 012-2h2V8a2 2 0 012-2h2V4a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2zM4 15h10a1 1 0 001-1V4a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 01-1 1H8a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 00-1 1v2a1 1 0 001 1z"
  })));
});
export default SvgStairsicon;